var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormButton',{staticClass:"toggle-chat-button",attrs:{"title":_vm.title},on:{"click":_vm.toggleChat}},[_c('DynamicIcon',{attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }